module.exports = __webpack_public_path__ + "static/media/achievement-bronze-slipper.ea333c0a.svg";